<template>
  <div class="cost">
    <p class="page-title">Apply Your Knowledge</p>
    <h1 class="question">Which Material is More Cost Efficient?</h1>

    <div class="two-answers">
      <div class="answer" 
      v-for="material of materials"
      :key="material.id"
      @click="checkAll === false ? picked = material.id : ''"
      :style="{pointerEvents: checkAll === true ? 'none' : 'auto' }"
      :class="{
      'picked': picked === material.id,
      'correct': checkAll === true && (material.correctCost === true && picked === material.id || material.correctCost === false && picked !== material.id) ,
      'wrong': checkAll === true && (material.correctCost === true && picked !== material.id || material.correctCost === false && picked === material.id),
      'fade': checkAll === true && picked !== material.id}">

        <div class="symbol-contain" v-if="checkAll">
          <div class="symbol-color">
            <span class="symbol" v-if="material.correctCost === true && picked === material.id || material.correctCost === false && picked !== material.id">
              &check;
            </span>
            <span class="symbol" v-if="material.correctCost === true && picked !== material.id || material.correctCost === false && picked === material.id">
              &times;
            </span>
            <p class="heat-capacity-answer">Total = ${{ material.totalCost }}</p>
          </div>
        </div>


        <div class="box">
          <p class="text">{{material.text}}</p>
          <Dots :fill="material.fill" :wiggle="material.wiggle" :w="200" :h="200" :r="40" />
        </div>
          <div class="rows" v-if="checkAll === false">
            <div class="row">
              <p>Material Costs</p>
              <p>{{ material.materialCosts }}</p>
            </div>
            <div class="row">
              <p>Labor</p>
              <p>{{ material.labor }}</p>
            </div>
            <div class="row">
              <p>Total Time</p>
              <p>{{ material.totalTime }} Hrs</p>
            </div>
          </div>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <p class="explination" v-if="checkAll === true">Total cost = Materials cost + (Labor cost)(Time)</p>
    </transition>

    <button class="btn" @click="checkAll = true;" v-if="!checkAll">Continue &RightArrow;</button>
    <router-link to="/final" class="btn" v-if="checkAll">Continue &RightArrow;</router-link>

  </div>
</template>


<script>
import Dots from '../components/Dots'
import { mapGetters } from 'vuex'
export default {
  components: {
    Dots
  },
  data() {
    return {
      picked: '',
      checkAll: false,
      answers: []
    }
  },
  computed: mapGetters({materials: 'getCosts'}),
}
</script>


<style lang="scss" scoped>
  
  .cost{
    max-width: 69rem;
    margin: 0 auto;
    padding: 3rem;

    .question{
      font-size: 2rem;
      font-weight: bold;
      margin-top: 3rem;
    }

    .two-answers{
      display: flex;
      width: 100%;
      justify-content: center;
      margin: 2rem 0;

      .answer{
        cursor: pointer;
        margin: 0 3rem;
        flex: 0 0 18rem;
        display: block;
        position: relative;

        .symbol-contain{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;

          .symbol-color{
            width: 80%;
            border-radius: 0.5rem;
            
            .symbol{
              font-size: 3.3rem;
              display: block;
              padding: 1rem;
              padding-bottom: 0.5rem;
            }

            p{
              margin: 0;
              margin-bottom: 1rem;
              font-size: 1.2rem;
            }

          }

        }

        .box{
          min-height: 18rem;
          box-shadow: 2px 2px 5px rgba($dark, 0.5);
          margin-bottom: 2rem;
          border: solid 1px transparent;
          
        }

        .row{
            display: flex;

            p{
              flex: 1 1 70%;
              padding: 0.5rem .2rem;
              text-align: left;
              font-size: 1.3rem;
              margin: 0;

              &:last-of-type{
                flex: 0 0 30%;
              }
            }
          }
        

        .text{
          background: $light;
          margin: 0;
          padding: 1rem;
          margin-bottom: 1rem;
          transition: all 250ms;
        }

        &:hover{
          .text{
            background: $blue;
            color: #ffffff;
          }
        }

        &.picked{
          .text{
            background: $green;
            color: #ffffff;
          }
        }

        &.correct{
          .box{
            border-color: $green;
          }

          .symbol-color{
            background: rgba($green, 1);
            color: #ffffff;
            font-weight: bold;
            text-shadow: 1px 1px 0 darken($green, 10%);

            @supports(backdrop-filter: blur(5px)){
              backdrop-filter: blur(5px);
              background: rgba($green, 0.8);
            }
          }
        }

        &.wrong{
          .box{
            border-color: $red;
          }

          .symbol-color{
            background: rgba($red, 1);
            color: #ffffff;
            font-weight: bold;
            text-shadow: 1px 1px 0 darken($red, 10%);

            @supports(backdrop-filter: blur(5px)){
              backdrop-filter: blur(5px);
              background: rgba($red, 0.8);
            }
          }
        }

        &.fade{
          .box{
            opacity: 0.5;
          }

          .symbol-color{
            background: rgba($light, 1);
            font-weight: bold;
            text-shadow: 1px 1px 0 darken($light, 10%);

            .symbol{
              display: none;
            }

            .heat-capacity-answer{
              padding: 1rem 0;
              margin: 0;
              color: #000000;
            }

            @supports(backdrop-filter: blur(5px)){
              backdrop-filter: blur(5px);
              background: rgba($light, 0.8);
            }
          }
        }
      }
    }
  }

  .explination{
    font-size: 1.5rem;
    margin-bottom: 3rem;
  }

</style>